/**
 * Created by mark on 11/12/2017.
 */



import React from 'react';
import { Row, Col, Card } from 'react-bootstrap'
export default class Authentication extends React.Component {
    constructor(props) {
        super();
        this.props = props;
        this.state = {
            finishedCheck:false
        };
    }

    componentWillMount() {
    }

    render() {
        return <div>
            <Row>
                <Col>
                    <br />
                    <br />
                    <Card body>
                        <br />
                        <center style={{ top: '-50px', marginLeft: '-75px', left: '50%', position: 'absolute' }}><img height="150px" src="./img/logos/languagenut/no-text-logo.png" /></center>
                        <br />
                        <br />
                        <center><h1 class="display-4" style={{ marginBottom: '10px' }}>Thank You!<br /><small><small></small></small></h1></center>
                        <br />
                        <p>Thank you for signing up for Languagenut. To get your school access to the resources we need a short call with you to set up Languagenut to align to your curriculum. Please email me on <a href="mailto:elizabeth@edify.co.nz">elizabeth@edify.co.nz</a> to schedule a meeting.</p>
                        <b>Key Features</b>
                        <br />

                        <ul class="fa-ul">
                            <li><span class="fa-li"><i class="fas fa-check"></i></span><b>Primary/Elementary, Secondary/High and EAL/ESOL</b> resources.</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>8,000 exam-style questions - reading, writing, listening and speaking</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Pre-made assignments - <b>over 300 hours of tasks ready for home learning</b></li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Resources in <b>French, Maori, Spanish, German, Mandarin + 20</b> more languages</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>2,500+ vocabulary items</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Comprehensive grammar and verb activities</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Sentence building games</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Create your own content</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Set assignment/homework</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Comprehensive reporting, tracking and feedback for your students</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Practise forming full sentences and sentence chunks</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Improve your pronunciation with our engaging phonics activities</li>
                        </ul>

                        <hr />
                        <p>
                            <center>
                                <span style={{ fontStyle: 'italic' }}>"We are a Kura Kaupapa Māori, full immersion and have been using Language Nut for approximately 4 years. We have an open door policy and invite tamariki with no te reo Māori to attend the kura. These tamariki are essentially second language learners of te reo Māori, Languagenut has played a pivotal role in developing the oral language of these tamariki.
                                        I have also noted an improvement in the acquisition of new words amongst the tamariki who already speak Māori.
                                        Languagenut provides a fun and engaging way of learning language and is very popular with the tamariki. It also provides teachers with the ability to monitor their students progress, assign specific activities and celebrate their childrens learning with certificates.”
                                <br />
                                I would highly recommend it as a means to learn te reo Māori.
                                <br />
                                Denise Te Wake
                                </span>
                                <br />
                                <b>Te Kura Kaupapa Maori o Te Ara Rima, New Zealand</b>
                                <br />
                                <br />
                                <span style={{ fontStyle: 'italic' }}>"I teach a year 6 class at St Brigid’s School in Dunedin. The class are very lucky to be learning French and Mandarin as part of their regular program. We use Languagenut regularly to reinforce what the children have been learning in class. They complete set tasks and assessments as well as choosing topics of their own interest to pursue. The class all love Languagenut and enjoy their sessions on it.”
                                <br />
                                Deborah Whitty
                                </span>
                                <br />
                                <b>St Brigid's School, New Zealand</b>
                            </center>
                        </p>
                        <center>
                            <small>For any questions email <a href="mailto:elizabeth@edify.co.nz">elizabeth@edify.co.nz</a></small>
                            <br /><img height="80px" src="https://s3-eu-west-1.amazonaws.com/marketing.languagenut.com/Sales%20site/Languagenut%20Sales%20Sites%20Image%20Assets/LN%20Logo.png" />
                        </center>
                    </Card>
                </Col>
            </Row>
        </div>
    }
}